export const CaseTypesWithTrackingNumber = [
  'Greencard Renewal',
  'B-1',
  'B-2',
  'Extend/Change of Dependent Status',
  'Petition to Remove Conditions on Residence',
  'Reentry Permit',
  'B-1 in lieu of H',
  'B-1 OCS',
  'E-1',
  'E-2',
  'E-3',
  'H-1B',
  'H-1B1',
  'H-2A',
  'H-2B',
  'H-3',
  'I Foreign Media',
  'L-1',
  'NIV Approval Processing',
  'O-1',
  'P-1',
  'R-1',
  'TN',
];

export enum CaseDocumentsTabs {
  Timeline = 'timeline',
  CaseDocuments = 'case-documents',
  Questionnaire = 'questionnaire',
}
